import React, {Fragment} from 'react';
import { Slider, Typography, Grid, withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const RenderSliderRedux = props => {
    const { label,values, handleChange, ...other} = props
    const [value, setValue] = React.useState(values.areaSpace);
    const handleSliderChange = (event, newValue) => {
      setValue(newValue);
    };
    
    return (
        <Fragment>
            <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <Typography id="discrete-slider" gutterBottom>
                        {label}
                    </Typography>
                </Grid>
                <Grid item xs={1} md={1} lg={1} xl={1}/>
                <Grid item xs={10} md={10} lg={10} xl={10}>
                    <Slider
                        {...other}
                        value={typeof value === "number" ? value : 0}
                        onChange={handleSliderChange}
                        aria-labelledby="input-slider"
                        onChangeCommitted={(event, value) =>
                            handleChange("areaSpace")({ target: { value } })
                        }
                    />
                </Grid>
                <Grid item xs={1} md={1} lg={1} xl={1}/>
            </Grid>
        </Fragment>
    );
};

RenderSliderRedux.propTypes = {
    label: PropTypes.string.isRequired,
};

export default withStyles({
    root: {
      color: '#2E2757',
      height: 8,
    },
    thumb: {
      height: 24,
      width: 24,
      backgroundColor: '#fff',
      border: '2px solid currentColor',
      marginTop: -8,
      marginLeft: -12,
      '&:focus, &:hover, &$active': {
        boxShadow: 'inherit',
      },
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + 4px)',
    },
    track: {
      height: 8,
      borderRadius: 4,
    },
    rail: {
      height: 8,
      borderRadius: 4,
    },
  })(RenderSliderRedux);